import * as BVConstants from '../config/BVConstants';
import { fetchDataGetReq, fetchDataPostReq, fetchDataPutReq } from '../apis/apiUtil';

class MDMService {
  getDashRegLibraryCount(data) {
    const url = `getDashRegLibraryCountReact`;

    return fetchDataPutReq(url, data);
  }

  getDashListRegulatoryLibrary(data) {
    const url = `getDashListRegulatoryLibraryReact`;

    return fetchDataPutReq(url, data);
  }

  getRegLibKPICount(data) {
    const url = `getRegLibKPICount`;

    return fetchDataPutReq(url, data);
  }

  saveRegProposal(data) {
    const url = `saveRegProposal`;

    return fetchDataPostReq(url, data);
  }

  getRegLibraryQueryDetail(data) {
    const url = `getRegLibraryQueryDetail`;

    return fetchDataPutReq(url, data);
  }

  shareRegLibFurtherQuery(data) {
    const url = `shareRegLibFurtherQuery`;

    return fetchDataPutReq(url, data);
  }

  saveRegLibFilter(data){
    const url = `saveRegLibFilter`;
    
    return fetchDataPutReq(url, data);
  }

  getRegLibFilter(data){
    const url = `getRegLibFilter`;
    
    return fetchDataPutReq(url, data);
  }

  shareRegLibInfo(data){
    const url = `shareRegLibInfo`;
    
    return fetchDataPutReq(url, data);
  }

  saveRegLibraryQuery(data){
    const url = `saveRegLibraryQuery`;
    
    return fetchDataPostReq(url, data);
  }

  getRegulatoryLibraryQuery(data){
    const url = `getRegulatoryLibraryQuery`;
    
    return fetchDataPutReq(url, data);
  }

  saveClientProfileDetails(data){
    const url = `saveClientProfileDetails`;
    
    return fetchDataPutReq(url, data);
  }

  getClientProfileDetails(data){
    const url = `getClientProfileDetails`;
    
    return fetchDataPutReq(url, data);
  }

  getRegLibSearchSuggestions(data){
    const url = `getRegLibSearchSuggestions`;
    
    return fetchDataPostReq(url, data);
  }
}

const mdmService = new MDMService();
export default mdmService;